// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"12bc431a","453":"5e443b8b","455":"066f1021","665":"10303550","704":"4545d45e","977":"95a77d46"}[chunkId] + ".chunk.js";
};